export default __webpack_public_path__ + "static/media/hnz_list_item.0027cd80.png";